import { Locale as DateFnsLocale } from 'date-fns';
import { enUS, es, pt } from 'date-fns/locale';

import { Locale } from '@/types/locale';

export const toDateFnsLocale = (locale: Locale): DateFnsLocale => {
  switch (locale) {
    case 'pt':
      return pt;
    case 'es':
      return es;
    default:
      return enUS;
  }
};
